import { render, staticRenderFns } from "./EventCancelledReportForm.vue?vue&type=template&id=8d75426a&"
import script from "./EventCancelledReportForm.vue?vue&type=script&lang=js&"
export * from "./EventCancelledReportForm.vue?vue&type=script&lang=js&"
import style0 from "./EventCancelledReportForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
